// Lead Time Modal Functions
function openLeadTimeModal() {
  const overlay = document.querySelector('[data-lead-time-modal-overlay]');
  const modal = document.querySelector('[data-lead-time-modal]');

  if (!overlay || !modal) return;

  modal.classList.add('is-visible');
  overlay.classList.add('is-visible');

  // Prevent body scroll
  document.body.style.overflow = 'hidden';

  // Focus on first input
  const firstInput = modal.querySelector('.lead-time-modal__input');
  if (firstInput) {
    setTimeout(() => firstInput.focus(), 100);
  }
}

function closeLeadTimeModal() {
  const overlay = document.querySelector('[data-lead-time-modal-overlay]');
  const modal = document.querySelector('[data-lead-time-modal]');

  if (!overlay || !modal) return;

  modal.classList.remove('is-visible');
  overlay.classList.remove('is-visible');

  // Restore body scroll
  document.body.style.overflow = '';
}

// Initialize modal triggers
function initLeadTimeModal() {
  const triggers = document.querySelectorAll('[data-lead-time-modal-trigger]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openLeadTimeModal();
    });
  });

  const closeButton = document.querySelector('[data-lead-time-modal-close]');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeLeadTimeModal();
    });
  }

  // Close on overlay click
  const overlay = document.querySelector('[data-lead-time-modal-overlay]');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeLeadTimeModal();
      }
    });
  }

  // Close when clicking outside modal content
  const modal = document.querySelector('[data-lead-time-modal]');
  if (modal) {
    modal.addEventListener('click', (e) => {
      const content = modal.querySelector('.lead-time-modal__content');
      if (content && !content.contains(e.target)) {
        closeLeadTimeModal();
      }
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modal = document.querySelector('[data-lead-time-modal]');
      if (modal && modal.classList.contains('is-visible')) {
        closeLeadTimeModal();
      }
    }
  });

  // Auto-open modal if form was just submitted (success or error messages present)
  if (modal) {
    const hasSuccess = modal.querySelector('.lead-time-modal__success-message');
    const hasError = modal.querySelector('.lead-time-modal__error-message');
    if (hasSuccess || hasError) {
      openLeadTimeModal();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLeadTimeModal);
} else {
  initLeadTimeModal();
}

// Make functions globally available
window.openLeadTimeModal = openLeadTimeModal;
window.closeLeadTimeModal = closeLeadTimeModal;
